var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_2461)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_261_2461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7002 23.15C1.7002 21.1618 3.31197 19.55 5.3002 19.55H34.1002C36.0884 19.55 37.7002 21.1618 37.7002 23.15V47.1501C37.7002 49.1383 36.0884 50.75 34.1002 50.75H5.30019C3.31197 50.75 1.7002 49.1383 1.7002 47.15V23.15Z",
    fill: "#43CDEC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.7002 23.15C1.7002 21.1618 3.31197 19.55 5.3002 19.55H34.1002C36.0884 19.55 37.7002 21.1618 37.7002 23.15V47.1501C37.7002 49.1383 36.0884 50.75 34.1002 50.75H5.30019C3.31197 50.75 1.7002 49.1383 1.7002 47.15V23.15Z",
    stroke: "#292D32",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_261_2461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7002 23.15C16.7002 21.1618 18.312 19.55 20.3002 19.55H46.7002C48.6884 19.55 50.3002 21.1618 50.3002 23.15V47.1501C50.3002 49.1383 48.6884 50.75 46.7002 50.75H20.3002C18.312 50.75 16.7002 49.1383 16.7002 47.15V23.15Z",
    fill: "#43CDEC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.7002 23.15C16.7002 21.1618 18.312 19.55 20.3002 19.55H46.7002C48.6884 19.55 50.3002 21.1618 50.3002 23.15V47.1501C50.3002 49.1383 48.6884 50.75 46.7002 50.75H20.3002C18.312 50.75 16.7002 49.1383 16.7002 47.15V23.15Z",
    stroke: "#292D32",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9 20.1501H41.6L33.2 50.1501H27.5L35.9 20.1501Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.65 20.1501H34.55L26.15 50.1501H25.25L33.65 20.1501Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_261_2461)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.7002,
    y: 27.3501,
    width: 16.95,
    height: 0.9,
    rx: 0.45,
    fill: "#292D32",
    stroke: "#292D32",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2871 29.8782C33.2871 34.758 31.2771 37.2306 27.3034 37.2306C22.0603 37.2306 20.1891 33.7163 20.1891 30.4212C20.1891 29.5988 19.965 29.4891 19.6629 29.356C19.2351 29.1654 19.2022 27.9278 19.244 27.3197C19.2487 27.2517 19.3019 27.1967 19.3692 27.186C25.0263 26.2818 27.8476 26.2136 31.5143 26.9654C32.4019 27.1474 32.8157 27.6691 33.038 28.4045H36.5206C36.7477 27.6691 37.1703 27.1474 38.0769 26.9654C41.8223 26.2135 44.7041 26.2818 50.4835 27.1863C50.5509 27.1969 50.6042 27.2518 50.609 27.3198C50.6517 27.928 50.6181 29.1654 50.1813 29.356C49.8727 29.4891 49.6438 29.5988 49.6438 30.4212C49.6438 33.7163 47.7327 37.2306 42.3777 37.2306C38.3191 37.2306 36.2662 34.758 36.2662 29.8782C36.293 29.6193 36.3218 29.3711 36.3588 29.1362H33.1965C33.2327 29.3711 33.2609 29.6193 33.2871 29.8782Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2871 29.8782H34.3371V29.8252L34.3318 29.7724L33.2871 29.8782ZM19.6629 29.356L19.2356 30.3151L19.2394 30.3168L19.6629 29.356ZM19.244 27.3197L20.2916 27.3917L19.244 27.3197ZM19.3692 27.186L19.5349 28.2228L19.5349 28.2228L19.3692 27.186ZM31.5143 26.9654L31.3034 27.994L31.5143 26.9654ZM33.038 28.4045L32.033 28.7084L32.2586 29.4545H33.038V28.4045ZM36.5206 28.4045V29.4545H37.2953L37.5239 28.7143L36.5206 28.4045ZM38.0769 26.9654L38.2835 27.9949L38.0769 26.9654ZM50.4835 27.1863L50.6458 26.149V26.149L50.4835 27.1863ZM50.609 27.3198L49.5616 27.3933V27.3934L50.609 27.3198ZM50.1813 29.356L50.5973 30.32L50.6011 30.3184L50.1813 29.356ZM36.2662 29.8782L35.2218 29.7702L35.2162 29.824V29.8782H36.2662ZM36.3588 29.1362L37.396 29.2994L37.5869 28.0862H36.3588V29.1362ZM33.1965 29.1362V28.0862H31.9724L32.1587 29.2961L33.1965 29.1362ZM27.3034 38.2806C29.5197 38.2806 31.3524 37.5802 32.5999 36.047C33.8144 34.5543 34.3371 32.4363 34.3371 29.8782H32.2371C32.2371 32.1999 31.7549 33.7581 30.9709 34.7217C30.2199 35.6447 29.0608 36.1806 27.3034 36.1806V38.2806ZM19.1391 30.4212C19.1391 32.2521 19.6577 34.2224 20.9881 35.7509C22.3417 37.3062 24.4289 38.2806 27.3034 38.2806V36.1806C24.9348 36.1806 23.4648 35.3978 22.5721 34.3722C21.6561 33.3198 21.2391 31.8854 21.2391 30.4212H19.1391ZM19.2394 30.3168C19.2776 30.3336 19.2946 30.3414 19.3063 30.3472C19.3162 30.3521 19.3096 30.3494 19.2947 30.3396C19.2785 30.329 19.2538 30.3107 19.2264 30.2838C19.1985 30.2564 19.1741 30.2262 19.1544 30.1953C19.1149 30.1335 19.113 30.0989 19.12 30.1335C19.1276 30.1715 19.1391 30.2585 19.1391 30.4212H21.2391C21.2391 29.9531 21.1832 29.4705 20.9242 29.0649C20.6407 28.621 20.2236 28.4557 20.0863 28.3952L19.2394 30.3168ZM18.1965 27.2476C18.1722 27.6006 18.1682 28.1376 18.2372 28.6379C18.2713 28.8848 18.3297 29.174 18.4398 29.4419C18.5364 29.677 18.7557 30.1013 19.2356 30.3151L20.0902 28.3968C20.3561 28.5153 20.4109 28.7135 20.3823 28.6439C20.3672 28.6072 20.3399 28.5133 20.3175 28.3509C20.2736 28.0327 20.274 27.6468 20.2916 27.3917L18.1965 27.2476ZM19.2034 26.1491C18.6833 26.2323 18.2368 26.6625 18.1965 27.2476L20.2916 27.3917C20.2607 27.8409 19.9205 28.1612 19.5349 28.2228L19.2034 26.1491ZM31.7252 25.9368C27.8836 25.1491 24.9212 25.2352 19.2034 26.1491L19.5349 28.2228C25.1313 27.3283 27.8116 27.278 31.3034 27.994L31.7252 25.9368ZM34.0431 28.1006C33.9009 27.6302 33.6727 27.1444 33.2725 26.7394C32.8631 26.325 32.3406 26.063 31.7252 25.9368L31.3034 27.994C31.5757 28.0498 31.7039 28.1397 31.7788 28.2154C31.863 28.3007 31.9529 28.4434 32.033 28.7084L34.0431 28.1006ZM33.038 29.4545H36.5206V27.3545H33.038V29.4545ZM37.5239 28.7143C37.6049 28.4518 37.6959 28.3095 37.783 28.2233C37.8618 28.1452 37.9979 28.0522 38.2835 27.9949L37.8702 25.936C37.2493 26.0606 36.7208 26.3194 36.3049 26.7316C35.8972 27.1355 35.6634 27.6218 35.5174 28.0947L37.5239 28.7143ZM38.2835 27.9949C41.8575 27.2773 44.6012 27.3285 50.3211 28.2237L50.6458 26.149C44.8071 25.2351 41.7871 25.1496 37.8702 25.936L38.2835 27.9949ZM50.3211 28.2237C49.9352 28.1633 49.5932 27.8436 49.5616 27.3933L51.6564 27.2462C51.6153 26.6599 51.1665 26.2305 50.6458 26.149L50.3211 28.2237ZM49.5616 27.3934C49.5794 27.6474 49.5798 28.0317 49.5353 28.3479C49.5125 28.5093 49.4849 28.6016 49.4702 28.6366C49.4429 28.7018 49.4991 28.508 49.7614 28.3935L50.6011 30.3184C51.0819 30.1086 51.3061 29.6887 51.4066 29.4492C51.5197 29.1797 51.5798 28.8889 51.6147 28.641C51.6855 28.1389 51.6813 27.6003 51.6564 27.2462L49.5616 27.3934ZM49.7652 28.3919C49.6273 28.4514 49.2057 28.6144 48.9174 29.0564C48.6514 29.4642 48.5938 29.9508 48.5938 30.4212H50.6938C50.6938 30.2594 50.7055 30.1739 50.7129 30.1377C50.7196 30.1052 50.717 30.1413 50.6762 30.2038C50.656 30.2348 50.6312 30.2648 50.6034 30.2916C50.5761 30.3178 50.5518 30.3353 50.5365 30.3451C50.5224 30.3542 50.5167 30.3564 50.5276 30.3511C50.5402 30.3449 50.5583 30.3369 50.5973 30.32L49.7652 28.3919ZM48.5938 30.4212C48.5938 31.88 48.1698 33.3113 47.2341 34.364C46.3197 35.3926 44.8096 36.1806 42.3777 36.1806V38.2806C45.3008 38.2806 47.4238 37.3114 48.8036 35.7592C50.1622 34.2309 50.6938 32.2575 50.6938 30.4212H48.5938ZM42.3777 36.1806C40.5704 36.1806 39.3774 35.6397 38.6076 34.7133C37.8074 33.7504 37.3162 32.1958 37.3162 29.8782H35.2162C35.2162 32.4404 35.7514 34.562 36.9924 36.0554C38.2637 37.5852 40.1264 38.2806 42.3777 38.2806V36.1806ZM37.3107 29.9861C37.3367 29.7338 37.3633 29.5071 37.396 29.2994L35.3215 28.973C35.2803 29.2352 35.2492 29.5048 35.2218 29.7702L37.3107 29.9861ZM36.3588 28.0862H33.1965V30.1862H36.3588V28.0862ZM34.3318 29.7724C34.305 29.5072 34.2746 29.238 34.2343 28.9763L32.1587 29.2961C32.1908 29.5043 32.2169 29.7315 32.2425 29.9839L34.3318 29.7724Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.0996,
    cy: 31.3999,
    r: 2.25,
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.7998,
    cy: 31.3999,
    r: 2.25,
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3747 31.175C20.3746 29.825 20.0747 26.825 22.6997 26.825",
    stroke: "#292D32",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4749 31.175C49.475 29.825 49.7749 26.825 47.1499 26.825",
    stroke: "#292D32",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7.99961,
    cy: 37.2501,
    r: 5.4,
    fill: "#1F2024",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_261_2461)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.8502,
    cy: 35.6,
    r: 5.4,
    fill: "#FF9D43"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7.8502,
    cy: 35.6,
    r: 5.4,
    stroke: "#292D32",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34961 32C9.89566 32.2907 10.3625 32.7611 10.6996 33.35",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_261_2461)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.85,
    cy: 35.6,
    r: 3.6,
    fill: "#FF9D43"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4.85,
    cy: 35.6,
    r: 3.6,
    stroke: "#292D32",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4004 41.175H36.2254",
    stroke: "#292D32",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_261_2461)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.09961,
    y: 12.8999,
    width: 34.95,
    height: 6.15,
    rx: 0.3,
    fill: "#FF9D43"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8.09961,
    y: 12.8999,
    width: 34.95,
    height: 6.15,
    rx: 0.3,
    stroke: "#292D32",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ii_261_2461)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.8496,
    y: 7.94995,
    width: 27.45,
    height: 4.95,
    rx: 0.3,
    fill: "#FF9D43"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.8496,
    y: 7.94995,
    width: 27.45,
    height: 4.95,
    rx: 0.3,
    stroke: "#292D32",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ii_261_2461)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5498,
    y: 4.05005,
    width: 22.05,
    height: 3.9,
    rx: 0.3,
    fill: "#FF9D43"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 14.5498,
    y: 4.05005,
    width: 22.05,
    height: 3.9,
    rx: 0.3,
    stroke: "#292D32",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ii_261_2461)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.4502,
    y: 0.449951,
    width: 14.25,
    height: 3.6,
    rx: 0.3,
    fill: "#FF9D43"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.4502,
    y: 0.449951,
    width: 14.25,
    height: 3.6,
    rx: 0.3,
    stroke: "#292D32",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_261_2461",
    x: 1.10059,
    y: 18.95,
    width: 37.1992,
    height: 32.4001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_261_2461"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_261_2461",
    result: "effect2_innerShadow_261_2461"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_261_2461",
    x: 16.1006,
    y: 18.95,
    width: 34.7998,
    height: 32.4001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -24,
    dy: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_261_2461"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_261_2461",
    x: -2.90039,
    y: 25.3999,
    width: 54.5732,
    height: 16.8806,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_261_2461"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_261_2461",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_261_2461",
    x: 1.85059,
    y: 29.5999,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: -8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_261_2461"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_261_2461",
    x: 0.650391,
    y: 31.3999,
    width: 8.39941,
    height: 8.40015,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: -8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_261_2461"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_261_2461",
    x: 7.5,
    y: 12.2998,
    width: 36.1494,
    height: 7.3501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_261_2461"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_261_2461",
    result: "effect2_innerShadow_261_2461"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ii_261_2461",
    x: 11.25,
    y: 7.34985,
    width: 28.6494,
    height: 6.15015,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_261_2461"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_261_2461",
    result: "effect2_innerShadow_261_2461"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii_261_2461",
    x: 13.9502,
    y: 3.44995,
    width: 23.25,
    height: 5.1001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_261_2461"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_261_2461",
    result: "effect2_innerShadow_261_2461"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ii_261_2461",
    x: 17.8506,
    y: -0.150146,
    width: 15.4492,
    height: 4.80005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_261_2461"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_261_2461",
    result: "effect2_innerShadow_261_2461"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_2461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlert);
export default __webpack_public_path__ + "static/media/warning_alert.ef166be0942cd4cf198b54c4221e91e5.svg";
export { ForwardRef as ReactComponent };